// useLocationSearch.js
import { useEffect, useState } from 'react';

export default function useLocationSearch(query) {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!query || query.length < 3) {
      setResults([]);
      return;
    }
    const ctrl = new AbortController();
    const t = setTimeout(async () => {
      setLoading(true);
      try {
        const url = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&countrycodes=in&format=json&limit=6`;
        const res = await fetch(url, { signal: ctrl.signal, headers: { 'Accept-Language': 'en' } });
        const json = await res.json();
        setResults(json.map((r) => ({
          label: r.display_name,
          lat: parseFloat(r.lat),
        lng: parseFloat(r.lon),
        })));
      } catch (err) {
        if (err.name !== 'AbortError') setResults([]);
      } finally {
        setLoading(false);
      }
    }, 350);
    return () => { ctrl.abort(); clearTimeout(t); };
  }, [query]);

  return { results, loading };
}